import {
  useQueryClient,
  type InvalidateQueryFilters,
} from '@tanstack/react-query';

import { useSandboxContext } from '@/providers/SandboxProvider';

export const useInvalidateAppQuery = () => {
  const queryClient = useQueryClient();
  const { gameCode, selectedSandbox } = useSandboxContext();

  return ({ queryKey, ...filters }: InvalidateQueryFilters) => {
    const scopedFilters: InvalidateQueryFilters = {
      ...filters,
      queryKey: queryKey ? [gameCode, selectedSandbox, ...queryKey] : undefined,
    };
    return queryClient.invalidateQueries(scopedFilters);
  };
};
